
import { defineComponent } from "vue";
import { useStore } from "vuex";
import "@/styles/variables.css";
import "@/styles/main-grid.css";
import "@/styles/extracted.css";
import BuildSpecial from "@/components/build/BuildSpecial.vue"; // @ is an alias to /src
import CharStats from "@/components/shared/CharStats/CharStats.vue";
import BuildSkills from "@/components/build/BuildSkills.vue";
import Traits from "@/components/build/Traits.vue";
import InfoPanel from "@/components/shared/InfoPanel/InfoPanel.vue";
import BuildPool from "@/components/build/BuildPool.vue";
import ControlPanel from "@/components/shared/ControlPanel.vue";
import LevelSpecial from "@/components/level/LevelSpecial.vue";
import LevelSkills from "@/components/level/LevelSkills.vue";
import Actions from "@/components/level/Actions.vue";
import LevelPool from "@/components/level/LevelPool.vue";
import Perks from "@/components/level/Perks.vue";
import SupportPerks from "@/components/level/SupportPerks.vue";
import NavMenuLeft from "@/components/shared/NavMenu/NavMenuLeft.vue";
import NavMenuRight from "@/components/shared/NavMenu/NavMenuRight.vue";
import EmptyPerks from "@/components/level/EmptyPerks.vue";
import LoadMenu from "@/components/shared/LoadMenu/LoadMenu.vue";
import SaveMenu from "@/components/shared/SaveMenu/SaveMenu.vue";
import CraftMenu from "@/components/shared/CharStats/CraftMenu.vue";
import InventoryMenu from "@/components/shared/InventoryMenu/InventoryMenu.vue";
import Header from "@/components/shared/Header.vue";
import Footer from "@/components/shared/Footer.vue";

export default defineComponent({
  name: "Home",
  components: {
    BuildSpecial,
    CharStats,
    BuildSkills,
    Traits,
    InfoPanel,
    BuildPool,
    ControlPanel,
    LevelSpecial,
    LevelSkills,
    Actions,
    LevelPool,
    Perks,
    SupportPerks,
    EmptyPerks,
    LoadMenu,
    SaveMenu,
    CraftMenu,
    InventoryMenu,
    Header,
    Footer,
    NavMenuLeft,
    NavMenuRight,
  },
  setup() {
    const store = useStore();
    return {
      state: store.state,
    };
  },
});
